import { map } from 'lodash';
import toBlogPost from './toBlogPost';

const getBlogPosts = async ({ lang, limit, page }) => {
  const langString = lang === 'de' ? '/de' : '';
  const limitString = limit ? `&per_page=${limit}` : '';
  const pageString = page ? `&page=${page}` : '';
  const url = `https://eyefitu.ch${langString}/wp-json/wp/v2/posts?_embed${pageString}${limitString}`;

  const response = await fetch(url);

  const data = await response.json();

  const total = Number(response.headers.get('X-WP-TotalPages'));

  const posts = map(data, toBlogPost);

  return {
    total,
    posts,
  };
};

export default getBlogPosts;
